export default async function GetCoverDetails(
    policyNumber,
    distributorNo) {
    const url = "/api/TAL/PolicyDetails/GetCoverDetails?policyNumber=" + policyNumber + "&distributorNo=" + distributorNo;
    //const url = "https://adviser-local-sitecore10.delivery.lan" + "/api/TAL/PolicyDetails/GetCoverDetails?policyNumber=" + policyNumber + "&distributorNo=" + distributorNo; // note: local testing                          

    try {
        const response = await fetch(url, {
            "method": "GET"
        });

        if (!response) {
            throw Error("No response");
        } else if (!response.ok) {
            throw Error(response.statusText);
        }

        const result = await response.json();

        return result;
    } catch (error) {
        console.log(error);

    }
}
